<div class="insurance-editor">
    <header class="editor-header">
        <div>
            <span>Insurance advisory</span>
            <h1>{{ reportNo() }}</h1>
            <p>Photo evidence with clear descriptions for the client insurance document.</p>
        </div>
        <div class="actions">
            <button class="btn-secondary" type="button" (click)="goBack()">Back</button>
            <button class="btn-secondary" type="button" (click)="openAttachModal()" [disabled]="!activeReportId()">{{ attachedLabel() }}</button>
            <button class="btn-save" type="button" (click)="saveReport()" [disabled]="isSaving()">{{ isSaving() ? 'Saving...' : 'Save' }}</button>
            <button class="btn-generate" type="button" (click)="generatePdf()" [disabled]="isGenerating()">
                {{ isGenerating() ? 'Generating...' : 'Generate PDF' }}
            </button>
            <button class="btn-email" type="button" (click)="emailCustomer()" [disabled]="isSendingEmail() || isSaving() || isGenerating()">
                {{ isSendingEmail() ? 'Sending...' : 'Email Customer' }}
            </button>
        </div>
    </header>

    <div class="loading-card" *ngIf="isLoadingReport()">Loading report...</div>

    <main class="editor-layout" *ngIf="!isLoadingReport()">
        <aside class="details-panel">
            <section class="panel-card">
                <div class="panel-heading">
                    <h2>Basic Details</h2>
                    <p>Keeping this intentionally simple for the current client workflow.</p>
                </div>
                <label>
                    <span>Owner name</span>
                    <input [ngModel]="customerName()" (ngModelChange)="customerName.set($event)" placeholder="Owner or customer name">
                </label>
                <label>
                    <span>Customer email optional</span>
                    <input type="email" [ngModel]="customerEmail()" (ngModelChange)="customerEmail.set($event)" placeholder="customer@example.com">
                </label>
                <label>
                    <span>Address</span>
                    <textarea [ngModel]="jobAddress()" (ngModelChange)="jobAddress.set($event)" rows="4" placeholder="Property address"></textarea>
                </label>
                <label>
                    <span>Status</span>
                    <select [ngModel]="status()" (ngModelChange)="status.set($event)">
                        <option *ngFor="let option of statuses" [value]="option">{{ option }}</option>
                    </select>
                </label>
            </section>

            <section class="panel-card">
                <div class="panel-heading">
                    <h2>Advisory Notes</h2>
                    <p>These notes appear in the PDF under Advisory Notes.</p>
                </div>
                <label>
                    <span>Cause summary</span>
                    <textarea [ngModel]="causeSummary()" (ngModelChange)="causeSummary.set($event)" rows="4" placeholder="What caused the issue, based on the inspection"></textarea>
                </label>
                <label>
                    <span>Work completed</span>
                    <textarea [ngModel]="workCompleted()" (ngModelChange)="workCompleted.set($event)" rows="4" placeholder="Work completed during attendance"></textarea>
                </label>
                <label>
                    <span>Damage observed</span>
                    <textarea [ngModel]="damageObserved()" (ngModelChange)="damageObserved.set($event)" rows="4" placeholder="Visible damage or affected areas"></textarea>
                </label>
                <label>
                    <span>Recommendations</span>
                    <textarea [ngModel]="recommendations()" (ngModelChange)="recommendations.set($event)" rows="4" placeholder="Recommended next steps"></textarea>
                </label>
                <label>
                    <span>Limitations</span>
                    <textarea [ngModel]="limitations()" (ngModelChange)="limitations.set($event)" rows="4" placeholder="Inspection limitations or exclusions"></textarea>
                </label>
            </section>

            <section class="panel-card soft-note">
                <h3>Image Handling</h3>
                <p>Large photos are resized before saving, then fitted inside the PDF without cropping.</p>
            </section>
        </aside>

        <section class="image-workspace">
            <div class="workspace-heading">
                <div>
                    <h2>Images & Descriptions</h2>
                    <p>{{ reportItems().length }} items added</p>
                </div>
                <button class="btn-add-item" type="button" (click)="openModal()">Add Image</button>
            </div>

            <div class="empty-state" *ngIf="reportItems().length === 0">
                <p>No images have been added yet.</p>
                <button class="btn-add-item" type="button" (click)="openModal()">Add First Image</button>
            </div>

            <article class="image-card" *ngFor="let item of reportItems(); let i = index">
                <div class="image-frame" *ngIf="item.photoPreview">
                    <img [src]="item.photoPreview" alt="Insurance evidence">
                </div>
                <div class="image-description">
                    <h3>Image {{ i + 1 }}</h3>
                    <p>{{ item.description || 'No description provided.' }}</p>
                </div>
                <div class="image-actions">
                    <button type="button" (click)="moveItem(i, -1)" [disabled]="i === 0">Up</button>
                    <button type="button" (click)="moveItem(i, 1)" [disabled]="i === reportItems().length - 1">Down</button>
                    <button type="button" (click)="openModal(item, i)">Edit</button>
                    <button type="button" class="danger" (click)="removeItem(i)">Delete</button>
                </div>
            </article>
        </section>
    </main>
</div>

<div class="modal-overlay" *ngIf="isModalOpen()">
    <div class="modal-card">
        <div class="modal-header">
            <h3>{{ editingIndex() > -1 ? 'Edit Image' : 'Add Image' }}</h3>
            <button class="btn-close" type="button" (click)="closeModal()">x</button>
        </div>

        <div class="modal-body">
            <label class="upload-label">
                <input type="file" (change)="onFileSelected($event)" accept="image/*" class="file-input">
                <div class="upload-placeholder" *ngIf="!modalPhotoPreview()">
                    <span>Click to upload photo</span>
                </div>
                <img *ngIf="modalPhotoPreview()" [src]="modalPhotoPreview()" class="preview-img" alt="Preview">
            </label>

            <div class="label-row">
                <label>Description</label>
                <button class="btn-ai" type="button" (click)="refineText()" [disabled]="isRefining() || !modalDescription()">
                    {{ isRefining() ? 'Refining...' : 'Refine with AI' }}
                </button>
            </div>
            <textarea class="modal-textarea" [ngModel]="modalDescription()" (ngModelChange)="modalDescription.set($event)" rows="7" placeholder="Describe what the photo shows. Keep it clear and factual."></textarea>
        </div>

        <div class="modal-footer">
            <button class="btn-secondary" type="button" (click)="closeModal()">Cancel</button>
            <button class="btn-save" type="button" (click)="saveItem()" [disabled]="isPreparingPhoto() || isSaving()">
                {{ isPreparingPhoto() ? 'Preparing...' : (isSaving() ? 'Saving...' : 'Save Image') }}
            </button>
        </div>
    </div>
</div>

<div class="crop-modal-overlay" *ngIf="cropEditorOpen() && cropSourceDataUrl()">
    <section class="crop-dialog">
        <header class="crop-dialog-header">
            <div>
                <span>Crop evidence photo</span>
                <h2>Select the visible area for the report</h2>
            </div>
            <button class="btn-close" type="button" (click)="closeCropEditor()">x</button>
        </header>

        <div class="crop-dialog-body">
            <div
                #cropSurface
                class="crop-surface"
                (pointermove)="onCropPointerMove($event)"
                (pointerup)="endCropDrag($event)"
                (pointercancel)="endCropDrag($event)"
                (pointerleave)="endCropDrag($event)">
                <img [src]="cropSourceDataUrl()!" alt="Image to crop">
                <div class="crop-selection" [ngStyle]="cropBoxStyle()" (pointerdown)="startCropDrag($event, 'move')">
                    <span class="crop-grid grid-v one"></span>
                    <span class="crop-grid grid-v two"></span>
                    <span class="crop-grid grid-h one"></span>
                    <span class="crop-grid grid-h two"></span>
                    <button class="crop-handle handle-nw" type="button" (pointerdown)="startCropDrag($event, 'nw')"></button>
                    <button class="crop-handle handle-n" type="button" (pointerdown)="startCropDrag($event, 'n')"></button>
                    <button class="crop-handle handle-ne" type="button" (pointerdown)="startCropDrag($event, 'ne')"></button>
                    <button class="crop-handle handle-e" type="button" (pointerdown)="startCropDrag($event, 'e')"></button>
                    <button class="crop-handle handle-se" type="button" (pointerdown)="startCropDrag($event, 'se')"></button>
                    <button class="crop-handle handle-s" type="button" (pointerdown)="startCropDrag($event, 's')"></button>
                    <button class="crop-handle handle-sw" type="button" (pointerdown)="startCropDrag($event, 'sw')"></button>
                    <button class="crop-handle handle-w" type="button" (pointerdown)="startCropDrag($event, 'w')"></button>
                </div>
            </div>
            <p class="crop-meta" *ngIf="cropSourceWidth() && cropSourceHeight()">
                Source image: {{ cropSourceWidth() }} x {{ cropSourceHeight() }} px
            </p>
        </div>

        <footer class="crop-dialog-footer" (pointerdown)="endCropDrag($event)">
            <button class="btn-secondary" type="button" (click)="closeCropEditor()" [disabled]="isPreparingPhoto()">Cancel</button>
            <button class="btn-secondary" type="button" (click)="useFullImage()" [disabled]="isPreparingPhoto()">
                {{ isPreparingPhoto() ? 'Preparing...' : 'Use Full Image' }}
            </button>
            <button class="btn-save" type="button" (click)="applyCrop()" [disabled]="isPreparingPhoto()">
                {{ isPreparingPhoto() ? 'Preparing...' : 'Confirm Crop' }}
            </button>
        </footer>
    </section>
</div>

<div class="modal-overlay" *ngIf="attachModalOpen()" (click)="closeAttachModal()">
    <section class="attach-modal" (click)="$event.stopPropagation()">
        <header>
            <div>
                <span>Attach insurance report</span>
                <h2>{{ reportNo() }}</h2>
            </div>
            <button class="btn-close" type="button" (click)="closeAttachModal()">x</button>
        </header>

        <div class="attach-tabs">
            <button type="button" [class.active]="attachTab() === 'Project'" (click)="setAttachTab('Project')">Projects</button>
            <button type="button" [class.active]="attachTab() === 'Job'" (click)="setAttachTab('Job')">Jobs</button>
        </div>

        <div class="attach-list" *ngIf="!isLoadingAttachList(); else attachLoading">
            <button type="button" class="attach-item" *ngFor="let item of attachList()" (click)="attachToReference(item)">
                <strong>{{ referenceTitle(item) }}</strong>
                <span>{{ item.address || item.site_address || item.customer_name || item.status || item.id }}</span>
            </button>
            <div class="empty-list" *ngIf="attachList().length === 0">No {{ attachTab().toLowerCase() }} records found.</div>
        </div>

        <ng-template #attachLoading>
            <div class="empty-list">Loading {{ attachTab().toLowerCase() }} records...</div>
        </ng-template>
    </section>
</div>
